import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { useAppContext } from '../contexts/AppContext'
import { navItems } from 'constants/routes'
import { getRouteLabel } from './routes'

export default function SegmentPageTracker() {
  const history = useHistory()
  const { hubMode } = useAppContext()
  const _navItems = navItems[hubMode ?? 'PHASE_ONE']

  const trackPage = (pathname: string) => {
    if (!hubMode) return
    window.analytics.page(getRouteLabel(_navItems, pathname), {
      path: pathname,
    })
  }

  useEffect(() => {
    trackPage(history.location.pathname)
    return history.listen(location => trackPage(location.pathname))
  }, [history, hubMode])

  return null
}
